module.exports = __webpack_public_path__ + "img/cgc.d287353b.png";